module.exports = __webpack_public_path__ + "static/media/glass-cheers.305a2eda.svg";